import React from "react";
import { IElementType } from "@/types/ui.types";
import style from "./Container.module.scss";
import cn from "classnames";
const Container = ({
  children,
  cls
}: IElementType) => {
  return <div className={cn(style.wrapper, cls)} data-sentry-component="Container" data-sentry-source-file="Container.tsx">{children}</div>;
};
export default Container;